import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './ui/card';
import { Input } from './ui/input';
import { Button } from './ui/button';

const Login = ({ setUser }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isFirstUser, setIsFirstUser] = useState(false);

  useEffect(() => {
    // ping backend to determine if first user
    const check = async () => {
      try {
        await axios.get(`${API}/auth/me`); // will 401 if not logged in
      } catch (e) {
        // ignore
      }
    };
    check();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await axios.post(`${API}/auth/login`, { email: email.trim().toLowerCase(), password });
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      setUser(response.data.user);
      window.location.href = '/';
    } catch (err) {
      setError(err?.response?.data?.detail || 'Login failed');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <img 
            src="https://beastmodelegacy.com/wp-content/uploads/2021/07/LogoBEASTMODE.LEGACY.NEWgoldoval-1.png" 
            alt="BEASTMODE Legacy Logo" 
            className="h-56 mx-auto"
          />
        </div>
        <Card className="beast-card">
          <CardHeader>
            <CardTitle className="text-3xl title-gold text-center">Welcome Back</CardTitle>
            <CardDescription className="text-center text-slate-300">
              {isFirstUser ? 'Set up your admin account to get started' : ''}
              {!isFirstUser && (
                <p className="mt-1 text-[13px] text-slate-300 italic">
                  Win the morning. Own the day. Small actions stacked daily build legendary results.
                </p>
              )}
            </CardDescription>
          </CardHeader>
          <CardContent>
            {error && <div className="mb-3 text-red-400 text-sm">{error}</div>}
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Input 
                  className="input-dark" 
                  type="email" 
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div>
                <Input 
                  className="input-dark" 
                  type="password" 
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <Button type="submit" className="w-full btn-gold">Sign In</Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Login;
